import * as LottiePlayer from "@lottiefiles/lottie-player"

const Styles = {
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
  },
  lottie: {
    width: '100%',
    height: '100%',
  }
}

function App() {

  const queryParams = new URLSearchParams(window.location.search)

  const src = queryParams.get('src')

  return (
    <section style={Styles.container}>
      {src &&
      <lottie-player
        autoplay
        loop
        mode="normal"
        src={src}
        style={Styles.lottie}
      />}
    </section>
  )
}

export default App


//https://media.graphassets.com/WDObJYn4TaCjs9qy11qg